import MobxReactForm from 'mobx-react-form';
import dvr from 'mobx-react-form/lib/validators/DVR';
import validatorjs from 'validatorjs';
const plugins = {
    dvr: dvr({
        package: validatorjs
    })
};
export const fields = [
    {
        name: 'oldPassword',
        type: 'password',
        placeholder: 'forms.credentialsForm.placeholders.oldPassword',
        label: 'forms.credentialsForm.placeholders.oldPassword',
        // ADV-281: the new password lives at changePassword.password — a bare `password` made the
        // DVR validator throw "The selected field is not defined (password)" on every validation,
        // so the password change could never be submitted.
        rules: `string|required_with:changePassword.password`
    },
    {
        name: 'changePassword',
        label: 'Change password',
        fields: [
            {
                name: 'password',
                type: 'password',
                placeholder: 'forms.credentialsForm.placeholders.password',
                label: 'forms.credentialsForm.placeholders.password',
                // the profile's rule, matching the Sicherheit hint (securityForm.hint)
                rules: 'required|password_strong',
                value: ''
            },
            {
                name: 'password2',
                type: 'password',
                placeholder: 'forms.credentialsForm.placeholders.passwordConfirm',
                label: 'forms.credentialsForm.placeholders.passwordConfirm',
                rules: 'required|same:changePassword.password',
                value: ''
            }
        ]
    }
];
const hooks = {};
const options = {
    validateOnInit: false,
    validateOnChange: true
};
export default new MobxReactForm({ fields }, { plugins, hooks, options });
